// extracted by mini-css-extract-plugin
module.exports = {"cell":"style_cell__120v0oYAapdO7qABpBk3yM"};